/**
 * Layout Component
 * Provides consistent page structure with navbar, content area, and footer
 */

import { ReactNode } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

interface LayoutProps {
  children: ReactNode;
}

/**
 * Layout component
 * Wraps page content with consistent navigation and footer
 * Provides the main structure for all pages in the application
 * 
 * @param props - Component props
 * @param props.children - Page content to render between navbar and footer
 * @returns Layout component with navbar, content, and footer
 */
export function Layout({ children }: LayoutProps) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'var(--color-bg)'
    }}>
      <Navbar />
      <main style={{
        flex: '1',
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
